import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function ConversionBlock({ testId = "conversion-block" }) {
  return (
    <section
      data-testid={testId}
      style={{
        background: "var(--ink-2)",
        borderTop: "1px solid var(--line)",
        borderBottom: "1px solid var(--line)",
        padding: "64px 0",
      }}
    >
      <div className="site-container">
        <div
          className="cb-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: 28,
            alignItems: "center",
          }}
        >
          <style>{`
            @media (min-width: 900px) {
              [data-testid="${testId}"] .cb-grid {
                grid-template-columns: 1fr auto !important;
                gap: 56px !important;
              }
            }
          `}</style>
          <div>
            <span className="eyebrow-muted" style={{ display: "block", marginBottom: 14 }}>
              Hívjon vagy írjon
            </span>
            <h2 className="h2" style={{ margin: 0, maxWidth: 720 }}>
              Tudni szeretné, mibe kerül? <span style={{ color: "var(--gold)" }}>Mondja el a részleteket.</span>
            </h2>
            <p className="lead" style={{ marginTop: 16, maxWidth: 560 }}>
              Hamarosan visszahívom. A felmérés ingyenes, az ajánlat tételes.
            </p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10, minWidth: 240 }}>
            <a href="/#kapcsolat" data-testid={`${testId}-cta`} className="btn btn-gold" style={{ padding: "14px 22px" }}>
              Árajánlatkérés <ArrowRight size={14} />
            </a>
            <a href={COMPANY.phoneHref} data-testid={`${testId}-phone`} className="btn btn-ghost" style={{ padding: "14px 22px" }}>
              <Phone size={14} /> {COMPANY.phoneDisplay}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
